export enum Namespace {
  ADMIN = 'admin',
  COUNTRIES = 'countries',
  PATIENT = 'patient',
}
